import {useCallback, useEffect, useState} from 'react';
import {Button, makeStyles, TextField, ThemeProvider} from "@material-ui/core";
import {createTheme} from '@material-ui/core/styles';
import CreatorBtn from "../../../../atoms/creator/experienceBuilderEnterBtn";
import {useDispatch, useSelector} from "react-redux";
import {
  moveNextPage,
  updateUserMetrics,
  validateSessionCode
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import UtilService from "../../../../../helper/service";
import {apiClient} from "../../../../../config/apiClient";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {useHistory, useLocation} from "react-router";
import {Auth} from "@aws-amplify/auth";
import {Storage} from "@aws-amplify/storage";
import {v4 as uuid_v4} from "uuid";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import ImmersionModal from "../../../../atoms/modals/commonModal";
import Config from "../../../../../config/config";
import axios from 'axios';
import {useFeature} from 'flagged';
import lockIcon from '@material-ui/icons/Lock';
import Icon from '@material-ui/core/Icon';
import CustomSnackBar from "../../experienceManager/participantsDashboard/component/CustomSnackBar";

const useStyles = makeStyles(() => ({
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
  browseBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683'
  },
  cancelBtn: {
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#e0e0e0',
    },
    fontSize: '0.875rem',
    fontFamily: 'roboto-regular',
    borderRadius: 4,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  fileInput: {
    display: 'none'
  },
  creatorSubtitle: {
    marginTop:10
  },
  modelCss: {
    marginRight: 40
  },
  progress: {
    width: '100%',
    marginBottom: 30,
    marginTop: 30
  },
  linkError: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#de4a39'
  },
  anchor: {
    color: '#017AEF',
    textDecoration: 'none'
  },
}));

const PreRecordedVideoPath = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [uploadVideoProgress, setUploadVideoProgress] = useState(0);
  const [videoLink, setVideoLink] = useState();
  const {
    userMetrics, page, globalSaveSetting
  } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { configation } = useSelector((state: any) => state.video);
  const {
    asyncVideoUrl,
    asyncFileName,
    asyncFile,
    asyncExperienceName,
    isLink,
    streamType,
    surveyLink,
    advanceFeature,
    asyncFileType,
    enable_controls,
    enable_watermark,
    copyExperience,
    asyncLastActivePage,
    sessions,
    createReel,
    lastAsyncFileName,
    lastAsyncFile,
    lastAsyncVideoUrl,
    lastAsyncExperienceName,
    lastStreamType,
    lastIsLink,
    lastReelSessionCode,
    reelVDOSessionCods
  } = userMetrics;
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const [snackAlertType, handleSnackAlertType] = useState('');
  const [snackAlertMsg, handleSnackMsg] = useState('');
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [loading, setLoading] = useState(false);
  const [linkError, setLinkError] = useState(false);
  const [upload, setUpload] = useState<any>(null);
  const [batchAsyncRole, setBatchAsyncRole] = useState(false);
  const [showSizeAlarm, setShowSizeAlarm] = useState(false);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const braintrustSession = Config.BRAINTRUST_SIMULATE_SESSION && Config.BRAINTRUST_SIMULATE_SESSION.split(",");
  const braintrust = {
    url: braintrustSession && braintrustSession[0] && braintrustSession[0] ? braintrustSession[0] : "",
    title: braintrustSession && braintrustSession[1] && braintrustSession[1] ? braintrustSession[1] : "",
    thumbnail: braintrustSession && braintrustSession[2] && braintrustSession[2] ? braintrustSession[2] : "",
    duration: braintrustSession && braintrustSession[3] && braintrustSession[3] ? braintrustSession[3] : "",
    category: braintrustSession && braintrustSession[4] && braintrustSession[4] ? braintrustSession[4] : "",
    subcategory: braintrustSession && braintrustSession[5] && braintrustSession[5] ? braintrustSession[5] : "",
    streamType: braintrustSession && braintrustSession[6] && braintrustSession[6] ? braintrustSession[6] : "",
    stimulusType: braintrustSession && braintrustSession[7] && braintrustSession[7] ? braintrustSession[7] : "",
    braintrust_id: braintrustSession && braintrustSession[8] && braintrustSession[8] ? braintrustSession[8] : "",
    customer_id: braintrustSession && braintrustSession[9] && braintrustSession[9] ? braintrustSession[9] : "",
    session_code: braintrustSession && braintrustSession[10] && braintrustSession[10] ? braintrustSession[10] : "",
    session_started_at: braintrustSession && braintrustSession[11] && braintrustSession[11] ? braintrustSession[11] : "",
    session_ended_at: braintrustSession && braintrustSession[12] && braintrustSession[12] ? braintrustSession[12] : "",
    sample_video_link: braintrustSession && braintrustSession[13] && braintrustSession[13] ? braintrustSession[13] : "",
  };

  const hasFeatureUploadVideo = useFeature('feature_upload');
  const hasFeatureSurveyLink = useFeature('feature_survey_link');

  const theme = createTheme({
    palette: {
      primary: {
        main: "#3D7FDA"
      }
    },
    overrides: {
      MuiInputLabel: {
        root: {
          color: "#8F99A3",
          fontFamily: 'roboto-regular',
          fontSize: 14,
        }
      }
    }
  });

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13 && !loading) {
      if (isLink) {
        if (advanceFeature ? (asyncVideoUrl && asyncExperienceName && !linkError && UtilService.validateSurveyLink(surveyLink)) : (asyncVideoUrl && asyncExperienceName)) {
          uploadAndGoNext();
        }
      } else {
        if (advanceFeature ? (asyncFileName && asyncExperienceName && !linkError && UtilService.validateSurveyLink(surveyLink)) : (asyncFileName && asyncExperienceName)) {
          uploadAndGoNext();
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    if (history.location.hash !== '#media') {
      UtilService.addHashTag(history, location.pathname, 'media');
    }
    // check if user has the ability to create reel
    if (loginUserData && loginUserData.role_access) {
      if (loginUserData.role_access.length) {
        const batch_async = loginUserData.role_access.filter((val: any) => val.access_name === "batch_async");
        if (batch_async.length > 0 && batch_async[0].access_value) {
          setBatchAsyncRole(true)
        }
      }
    }
  }, []);

  const getSessionCode = async () => {
    const payload = {
      "requestor": "experience",
      "tenant_id": loginUserData.customer_id
    };
    const res = await apiClient(false).post('/registration/v2/session/tokens', payload);
    if (res && res.data && res.data.token) {
      const checkSession = await validateSessionCode(apolloClient.client, res.data.token);
      if (checkSession && checkSession.data && checkSession.data.validateSessionCode) {
        localStorage.setItem("session_code", String(res.data.token));
        return res.data.token;
      } else {
        getSessionCode()  
      }
    } else {
      getSessionCode()
    }
    return '';
  };

  const onUploadReelVideo = async (is_next: boolean) => {
    dispatch(updateUserMetrics('reelCanceled', false));
    setLoading(true);
    setUploadVideoProgress(0);
    !createReel && dispatch(updateUserMetrics('createReel', true));
    dispatch(updateUserMetrics('braintrust', null));
    const fetchedSessionCode = await getSessionCode();
    if (fetchedSessionCode) {
      if (!isLink) {
        const currentReelVDOSessionCodes = [...reelVDOSessionCods];
        currentReelVDOSessionCodes.push(fetchedSessionCode);
        dispatch(updateUserMetrics('reelVDOSessionCods', [...currentReelVDOSessionCodes]));
      }
      const res = await uploadFile(fetchedSessionCode);
      if (res) {
        if (!is_next) {
          // store current async experience info as last info
          dispatch(updateUserMetrics('lastAsyncFileName', asyncFileName));
          dispatch(updateUserMetrics('lastAsyncFile', asyncFile));
          dispatch(updateUserMetrics('lastAsyncVideoUrl', asyncVideoUrl));
          dispatch(updateUserMetrics('lastAsyncExperienceName', asyncExperienceName));
          dispatch(updateUserMetrics('lastStreamType', streamType));
          dispatch(updateUserMetrics('lastIsLink', isLink));
          dispatch(updateUserMetrics('lastReelSessionCode', fetchedSessionCode));
        }
        setTimeout(async () => {
          const thumbnail = await getSessionThumbnail(fetchedSessionCode);
          const currentSessions: any[] = [...sessions];
          currentSessions.push({
            'name': asyncExperienceName,
            'session_code': fetchedSessionCode,
            'img': thumbnail
          });
          dispatch(updateUserMetrics('sessions', currentSessions));
          if (is_next) {
            const reelSessionCode = await getSessionCode();
            dispatch(updateUserMetrics('sessionCode', reelSessionCode));
          }
          // init necessary user metrics
          if (isLink) {
            const videoURLElement: any = document.getElementById("videoUrl");
            videoURLElement.value = '';
          }
          dispatch(updateUserMetrics('linkUploaded', false));
          dispatch(updateUserMetrics('fileUploaded', false));
          dispatch(updateUserMetrics('asyncFileName', ''));
          dispatch(updateUserMetrics('asyncFile', null));
          dispatch(updateUserMetrics('asyncVideoUrl', ''));
          dispatch(updateUserMetrics('asyncExperienceName', ''));
          dispatch(updateUserMetrics('streamType', ''));
          dispatch(updateUserMetrics('isLink', true));
          if (is_next) {
            // remove last async experience info
            dispatch(updateUserMetrics('lastAsyncFileName', ''));
            dispatch(updateUserMetrics('lastAsyncFile', null));
            dispatch(updateUserMetrics('lastAsyncVideoUrl', ''));
            dispatch(updateUserMetrics('lastAsyncExperienceName', ''));
            dispatch(updateUserMetrics('lastStreamType', ''));
            dispatch(updateUserMetrics('lastIsLink', true));

            goNext();
          }
          setUpload(null);
          setLoading(false);
        }, 5000);
      } else {
        setLoading(false);
      }
    }
  };

  const getSessionThumbnail = async (session_code: string) => {
    const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${session_code}`);
    const stimulusList = res.data;
    if (stimulusList.length > 0) {
      if (stimulusList[0]['stimulus_status'] === "PROCESSING-SENTTOVDO") {
        if (stimulusList[0]['stimulus_type'] === "AUDIO") {
          return '/assets/icons/experiencebuilder/video-proccessing.png';
        } else {
          return '/assets/icons/experiencebuilder/video-proccessing.png';
        }
      } else {
        const thumbnails = stimulusList[0]['thumbnails'];
        if (thumbnails && thumbnails.length > 0) {
          if (stimulusList[0]['stimulus_type'] === "AUDIO") {
            return '';
          } else {
            const descendedThumbs = thumbnails.sort((a: any, b: any) => b.width - a.width);
            return descendedThumbs[0]['url'];
          }
        }
      }
    }
  };

  const uploadAndGoNext = async () => {
    setLoading(true);
    setUploadVideoProgress(0);
    const fetchedSessionCode = await getSessionCode();
    if (fetchedSessionCode) {

      dispatch(updateUserMetrics('sessionCode', fetchedSessionCode));
      if (braintrustSession && braintrust && braintrust.braintrust_id && braintrust.session_started_at && braintrust.session_ended_at && braintrust.sample_video_link === asyncVideoUrl) {
        dispatch(updateUserMetrics('streamType', braintrust.streamType));
        const payload = {
          source_session_code: braintrust.session_code,
          source_tenant_id: braintrust.customer_id,
          target_session_code: fetchedSessionCode,
          target_tenant_id: loginUserData.customer_id,
          created_by: loginUserData.username
        };
        await apiClient(true).post('/stimulus/v2/stimulus/copy', payload);
        dispatch(updateUserMetrics('braintrust', braintrust));
        const startDate = UtilService.getAsyncAddminuite();
        dispatch(updateUserMetrics('asyncStartDateTime', startDate));
        const diffrence = parseInt(braintrust.session_ended_at) - parseInt(braintrust.session_started_at)
        dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getDateAddseconds(startDate, diffrence)))
        dispatch(updateUserMetrics('isLink', true));
        dispatch(updateUserMetrics('content', braintrust.category));
        dispatch(updateUserMetrics('item', braintrust.subcategory));
        dispatch(updateUserMetrics('myOwn', false));
        dispatch(updateUserMetrics('streamType', braintrust.streamType));
        dispatch(updateUserMetrics('asyncParticipants', []));
        setLoading(false);
        dispatch(moveNextPage(!globalSaveSetting ? 3 : 4))
      } else {
        
        dispatch(updateUserMetrics('braintrust', null));
        const res = await uploadFile(fetchedSessionCode);
        setLoading(false);
        if (res) {
          goNext();
        }
      }
    }
  };

  const uploadFile = async (sCode: string) => {
    setUploadVideoProgress(0);
    if (!isLink) {
      dispatch(updateUserMetrics('streamType', 'VDO'));
    }
    const payload = {
      file: asyncFile ? asyncFile : null,
      fileName: asyncFileName,
      streamType: isLink ? streamType : 'VDO',
      stimulusType: asyncFileType,
      sessionCode: sCode,
      sortOrder: "1",
      tenantId: loginUserData.customer_id,
      stimulusAlias: encodeURI(asyncExperienceName),
      stimulusDescription: asyncVideoUrl ? asyncVideoUrl : ''
    };

    const res: any = await handleUpload(payload);
    if (res && res.key) {
      if (isLink) {
        dispatch(updateUserMetrics('linkUploaded', true));
        dispatch(updateUserMetrics('fileUploaded', false));
        dispatch(updateUserMetrics('asyncFileName', ''));
        dispatch(updateUserMetrics('asyncFile', null));
      } else {
        dispatch(updateUserMetrics('fileUploaded', true));
        dispatch(updateUserMetrics('linkUploaded', false));
        dispatch(updateUserMetrics('asyncVideoUrl', ''));
        onCloseProgressModal();
      }
      return true;
    } else {
      setUploadVideoProgress(0);
      dispatch(updateUserMetrics('linkUploaded', false));
      dispatch(updateUserMetrics('fileUploaded', false));
      return false;
    }
  };

  const handleUpload = async (payload: any) => {
    const {
      file,
      fileName,
      streamType
    } = payload;

    const fileId = uuid_v4();
    if (streamType === "YOUTUBE" || streamType === "VIMEO") {
      const fileKey = `uploads/${fileId}`;
      return await uploadToS3(fileId, fileKey, " ", payload);
    } else {
      const fileKey = `uploads/${fileId}-${fileName}`;
      return await uploadToS3(fileId, fileKey, file, payload);
    }
  };

  const uploadToS3 = async (fileId: any, fileKey: string, file: any, payload: any) => {
    const {
      sessionCode,
      sortOrder,
      tenantId,
      stimulusType,
      streamType,
      stimulusAlias,
      stimulusDescription
    } = payload;

    try {
      const currentUser = await Auth.currentUserInfo();
      const uploadStorage = Storage.put(fileKey, file, {
        progressCallback(progress: any) {
          setTimeout(() => {
            setUploadVideoProgress(progress.loaded / progress.total * 100)
          }, 500);
        },
        level: 'private',
        metadata: {
          FileId: fileId,
          SessionCode: sessionCode,
          SortOrder: sortOrder,
          TenantId: tenantId,
          StimulusType: stimulusType,
          StreamType: streamType,
          StimulusAlias: stimulusAlias,
          StimulusDescription: stimulusDescription,
          Email: currentUser.attributes.email,
          UserName: currentUser.username,
          Operation: copyExperience && copyExperience.url && copyExperience.url.split("/").pop() === asyncFileName && copyExperience.streamType === "VDO" ? "COPY" : "",
          Sourceid: copyExperience && copyExperience.url && copyExperience.url.split("/").pop() === asyncFileName && copyExperience.streamType === "VDO" && copyExperience.sourceId ? copyExperience.sourceId : ""
        }
      });
      setUpload(uploadStorage);
      return await uploadStorage;
    } catch (e) {
      setUploadVideoProgress(0);
    }
  };

  const goNext = () => {
    const nextPage = page + 1;
    dispatch(moveNextPage(nextPage));
    (asyncLastActivePage < nextPage) && dispatch(updateUserMetrics('asyncLastActivePage', nextPage));
  };

  const onChangeVideoUrl = async (event: any) => {
    const videoUrl = event.target.value;
    // We don't allow playlist.
    const isPlaylist = onCheckPlaylist(videoUrl);
    if (isPlaylist) return;

    setVideoLink(videoUrl);
    const baseUrl = UtilService.checkYoutubeVimeoURL(videoUrl) || !videoUrl;
    const cleandURL = videoUrl.replace('app=desktop&', '')
    if (baseUrl) {
      axios.get(`${baseUrl}${cleandURL}&format=json`)
        .then(() => setLinkError(false))
        .catch(() => setLinkError(true))
    } else {

    }

    let finalVideoUrl = videoUrl;
    if (videoUrl.includes('m.youtube.com')) {
      finalVideoUrl = videoUrl.replace('m.youtube.com', 'youtube.com');
    }

    if (UtilService.validateYouTubeUrl(videoUrl) || UtilService.validateVimeoUrl(videoUrl) || (braintrustSession && braintrust && braintrust.braintrust_id && braintrust.session_started_at && braintrust.session_ended_at && braintrust.sample_video_link === videoUrl)) {
      const streamType = UtilService.validateYouTubeUrl(videoUrl) ? 'YOUTUBE' : 'VIMEO';
      let response = null;
      if (streamType === 'YOUTUBE') {
        const encodedURL =encodeURIComponent(videoUrl);
        response = await axios.get(`https://www.youtube.com/oembed?url=${encodedURL}&format=json`);
      } else {
        response = await axios.get(`https://vimeo.com/api/oembed.json?url=${videoUrl}`);
      }
      if (response && response.status === 200) {
        const title = response.data['title'].normalize ("NFKD").replace (/[\u0300-\u036F]/g, "");
        dispatch(updateUserMetrics('asyncExperienceName', title));
      }
      dispatch(updateUserMetrics('asyncVideoUrl', finalVideoUrl));
      dispatch(updateUserMetrics('streamType', streamType));
    } else {
      if (!linkError) {
        dispatch(updateUserMetrics('asyncExperienceName', 'My Custom Video'));
        videoUrl.length > 8 && dispatch(updateUserMetrics('asyncVideoUrl', finalVideoUrl));
        dispatch(updateUserMetrics('streamType', 'YOUTUBE'));
      } else {
        dispatch(updateUserMetrics('asyncVideoUrl', ''));
        dispatch(updateUserMetrics('streamType', ''));
      }
    }
  };

  const onCheckPlaylist = (url: string) => {
    if (url.includes('&list=')) {
      dispatch(updateUserMetrics('asyncVideoUrl', ''));
      dispatch(updateUserMetrics('streamType', ''));

      handleSnackAlertType('error');
      handleSnackMsg('We noticed that your link is part of a set. Please add only the URL link for the video you actually want to measure.');
      setShownSnackAlert(true);
      return true;
    }

    return false;
  };

  const onChangeExperienceName = (event: any) => {
    const experienceName = event.target.value.normalize ("NFKD").replace (/[\u0300-\u036F]/g, "");
    window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });

    dispatch(updateUserMetrics('asyncExperienceName', experienceName));
  };

  const triggerInputFile = (fileInput: any) => {
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleFileInput = (e: any) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const fileName = file.name;

      // check updated file size and show alarm if size is bigger than 200 MB.
      const fileSize = file.size;
      const mFileSize = Number((fileSize / (1000 * 1000)).toFixed(2));
      if (mFileSize > 200) setShowSizeAlarm(true);
      else setShowSizeAlarm(false);

      // auto fill out experience name as selected filename
      const splitNameList = fileName.split('.');
      let autoFilledName = '';
      for (let i = 0; i < splitNameList.length - 1; i ++) {
        autoFilledName += splitNameList[i];
      }
      autoFilledName && dispatch(updateUserMetrics('asyncExperienceName', autoFilledName));

      const uniqueFileName = new Date().getTime() + '.' + fileName.split(".").pop();
      const fileType = UtilService.isValidAudio(fileName) ? 'AUDIO' : 'VIDEO';
      dispatch(updateUserMetrics('asyncFileName', uniqueFileName));
      dispatch(updateUserMetrics('asyncFileType', fileType));
      dispatch(updateUserMetrics('asyncFile', file));
    }
  };

  const toggleUploadMethod = (isLink: boolean) => {
    dispatch(updateUserMetrics('isLink', isLink));
  };

  const onChangeSurveyLink = (event: any) => {
    const surveyLink = event.target.value;
    dispatch(updateUserMetrics('surveyLink', surveyLink));
  };

  const onChangePlayerControl = (event: any) => {
    const enableControls = event.target.checked;
    dispatch(updateUserMetrics('enable_controls', enableControls));

  };

  const onChangeWatermark = (event: any) => {
    const enableWatermark = event.target.checked;
    dispatch(updateUserMetrics('enable_watermark', enableWatermark));
  };

  const toggleAdvancedFeature = () => {
    if (!loading) {
      dispatch(updateUserMetrics('advanceFeature', !advanceFeature));
    }
  };

  const onBlurVideoUrl = (event: any) => {
    const videoUrl = event.target.value;
    if (UtilService.validateYouTubeUrl(videoUrl) || UtilService.validateVimeoUrl(videoUrl)) {
      const txtname = document.getElementById("experienceName")
      txtname && txtname.focus()
    }
  };

  const onCloseProgressModal = useCallback(() => {
    upload && Storage.cancel(upload);
    setLoading(false);
    setUploadVideoProgress(0);
  }, [upload]);

  const onErrorVideo = (e: any) => {
    const isYoutubeVimeo = UtilService.checkYoutubeVimeoURL(videoLink || '');

    if (e.type === 'error') {
      if (!isYoutubeVimeo) {
        setLinkError(true);
      }
    } else {
      setLinkError(false);
    }
  };

  const onCancelAddVideo = () => {
    dispatch(updateUserMetrics('reelCanceled', true));
    if (lastAsyncExperienceName) {
      const currentSessions: any[] = [...sessions];
      const updatedSessions = currentSessions.filter((s: any) => s.session_code !== lastReelSessionCode);
      dispatch(updateUserMetrics('sessions', updatedSessions));

      if (lastIsLink) {
        const videoURLElement: any = document.getElementById("videoUrl");
        videoURLElement.value = lastAsyncVideoUrl;
      }
      dispatch(updateUserMetrics('asyncFileName', lastAsyncFileName));
      dispatch(updateUserMetrics('asyncFile', lastAsyncFile));
      dispatch(updateUserMetrics('asyncVideoUrl', lastAsyncVideoUrl));
      dispatch(updateUserMetrics('asyncExperienceName', lastAsyncExperienceName));
      dispatch(updateUserMetrics('streamType', lastStreamType));
      dispatch(updateUserMetrics('isLink', lastIsLink));
    } else {
      dispatch(moveNextPage(2));
    }
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  return (
    <div>
      <p className="creator-title mt-65">
        Awesome!
      </p>
      <p className='creator-main-title'>
        Now, let&#39;s add your video
      </p>
      <div className='creator-main-panel'>
        <div style={{ marginTop: '10px' }}>
          <div className="creator-description">
            <strong>Add the video</strong> you want to measure (it should be longer than 5 seconds to get accurate results).
          </div>
        </div>
        <ThemeProvider theme={theme}>
          {isLink ? (
            <TextField
              InputLabelProps={{
                classes: {
                  root: classes.label,
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: classes.underline,
                  error: classes.error
                }
              }}
              style={{ width: '100%' }}
              margin="normal"
              defaultValue={asyncVideoUrl}
              id="videoUrl"
              label="Link to video URL"
              name="videoUrl"
              onBlur={onBlurVideoUrl}
              onChange={onChangeVideoUrl}
              helperText={hasFeatureUploadVideo ? <span className="creator-helperText">
               <span title={"Upload from your computer"} onClick={() => toggleUploadMethod(false)}>or
                upload from your computer...</span></span> : 
                <span className="creator-helperText"><Icon component={lockIcon} color="primary" style={{ fontSize: 12 }}/> or
                upload from your computer...</span>
              }
            />
          ) : (
            <div style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <Button variant="contained"
                className={classes.browseBtn}
                onClick={() => triggerInputFile(fileInput)}
              >Browse</Button>
              <input
                type="file"
                id="fileUpload"
                className={classes.fileInput}
                ref={(fileInput: any) => setFileInput(fileInput)}
                onChange={(e: any) => handleFileInput(e)}
              />
              &nbsp;&nbsp;&nbsp;
              <TextField
                InputLabelProps={{
                  classes: {
                    root: classes.label,
                    focused: classes.focusedLabel,
                    error: classes.erroredLabel
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.underline,
                    error: classes.error
                  }
                }}
                inputProps={{ readOnly: true }}
                style={{ flex: 7 }}
                margin="normal"
                id="localVideoUrl"
                value={asyncFileName}
                label="Upload from your computer"
                name="localVideoUrl"
                helperText={<span className="creator-helperText">
                  <span className="survey-link" title={"link from a URL"} onClick={() => toggleUploadMethod(true)}>or
                  link from a URL</span></span>}
              />
            </div>
          )}
          {linkError && (
            <span className={classes.linkError}>
              Unfortunately we have found an issue with your video. <br/>Please make sure the video you have used does not infringe upon copyrights and is publicly available.
            </span>
          )}
          {showSizeAlarm && (
            <span className={classes.linkError}>
              For best video playback, we suggest keeping your video under 200 MB. For more information, please consult our&nbsp;
              <a
                className={classes.anchor}
                rel="noreferrer"
                href={`${Config.INTERCOM_URL}/articles/6817251-best-practices-for-video-playback`}
                target={'_blank'}
              >
                video playback article
              </a>
            </span>
          )}

          {videoLink && <video style={{ display: 'none'}} onError={e => onErrorVideo(e)} controls src={videoLink} preload="auto" ></video>}

          {(asyncVideoUrl || asyncFileName) && !linkError && (
            <div>
              <p className={classes.creatorSubtitle + ' creator-subtitle'}>
                Excellent! Now let’s name your experience.
              </p>
              <TextField
                InputLabelProps={{
                  classes: {
                    root: classes.label,
                    focused: classes.focusedLabel,
                    error: classes.erroredLabel
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.underline,
                    error: classes.error
                  }
                }}
                style={{ width: '100%' }}
                value={asyncExperienceName}
                margin="normal"
                id="experienceName"
                label="Experience Name"
                autoFocus
                name="experienceName"
                onChange={onChangeExperienceName}
                helperText={isLink ? (
                  configation && configation.data && configation.data.EnableSurvey == "FALSE" ?
                    <></> : 
                    (hasFeatureSurveyLink ? 
                    <span className="creator-helperText"><span className="survey-link" onClick={() => toggleAdvancedFeature()}>Add post-experience survey
                  {advanceFeature ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </span></span>
                    :
                    <span className="creator-helperText"><Icon component={lockIcon} color="primary" style={{ fontSize: 12 }}/>Add post-experience survey</span>
                    )
                    
                    
                    ) : (
                  configation && configation.data && configation.data.EnableSurvey == "FALSE" && configation.data.EnableControls == "FALSE" && configation.data.EnableWatermark == "FALSE" ?
                    <></> : 
                    (hasFeatureSurveyLink ? 
                    <span className="creator-helperText"><span className="survey-link" onClick={() => toggleAdvancedFeature()}>Add post-experience survey
                    {advanceFeature ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </span></span>
                    :
                    <span className="creator-helperText"><Icon component={lockIcon} color="primary" style={{ fontSize: 12 }}/>Add post-experience survey</span>
                    )
                )}
              />
              {advanceFeature &&
                <>
                  {isLink ? (
                    <>
                      <p className="creator-survey-link-description">
                        <strong>Add a survey </strong> for participants to fill out after watching your video by adding a link below.
                      </p>
                      <TextField
                        InputLabelProps={{
                          classes: {
                            root: classes.label,
                            focused: classes.focusedLabel,
                            error: classes.erroredLabel
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.underline,
                            error: classes.error
                          }
                        }}
                        style={{ width: '100%', marginBottom: "20px" }}
                        margin="dense"
                        defaultValue={surveyLink}
                        id="surveyLink"
                        label="Survey Link"
                        name="surveyLink"
                        onChange={onChangeSurveyLink}
                      />
                    </>
                  ) : (
                    <>
                      {configation && configation.data && configation.data.EnableSurvey == "TRUE" ? <>
                        <p className="creator-survey-link-description">
                          <strong>Add a survey </strong> for participants to fill out after watching your video by adding a link below.
                        </p>
                        <TextField
                          InputLabelProps={{
                            classes: {
                              root: classes.label,
                              focused: classes.focusedLabel,
                              error: classes.erroredLabel
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: classes.underline,
                              error: classes.error
                            }
                          }}
                          style={{ width: '100%', marginBottom: "20px" }}
                          margin="dense"
                          defaultValue={surveyLink}
                          id="surveyLink"
                          label="Survey Link"
                          name="surveyLink"
                          onChange={onChangeSurveyLink}
                        /></> : <></>
                      }
                      {configation && configation.data && configation.data.EnableControls == "TRUE" ? <>

                        <FormControlLabel
                          control={
                            <Switch
                              checked={enable_controls}
                              onChange={onChangePlayerControl}
                              name="enable_controls"
                              color="primary"
                            />
                          }
                          label="Enable Player Control"
                        /></> : <></>}
                      {configation && configation.data && configation.data.EnableWatermark == "TRUE" ? <>

                        <FormControlLabel
                          control={
                            <Switch
                              checked={enable_watermark}
                              onChange={onChangeWatermark}
                              name="enable_watermark"
                              color="primary"
                            />
                          }
                          label="Enable Watermark"
                        />
                      </> : <></>
                      }
                    </>)}
                </>
              }
            </div>
          )}
        </ThemeProvider>
      </div>
      <ImmersionModal
        open={loading && !isLink}
        title={'Uploading...'}
        buttonDisable={true}
        onClose={() => onCloseProgressModal()}
        additional={
          <div className={classes.modelCss}>
            <div className={classes.progress}>
              <LinearProgress variant="determinate" value={uploadVideoProgress} />
            </div>
          </div>
        }
      />
      {createReel && !asyncExperienceName && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            className={classes.cancelBtn}
            onClick={onCancelAddVideo}
          >
            Cancel
          </Button>
        </div>
      )}
      {
        isLink ? (
          (advanceFeature ? (asyncVideoUrl && asyncExperienceName && !linkError) : (asyncVideoUrl && asyncExperienceName && !linkError)) && (
            <CreatorBtn
              showVideoBtn={true}
              enableVideoBtn={batchAsyncRole}
              loading={loading}
              uploadVideo={() => onUploadReelVideo(false)}
              goNext={() => createReel ? onUploadReelVideo(true) : uploadAndGoNext()}
              isValidation={surveyLink ? !UtilService.validateSurveyLink(surveyLink) : false}
            />
          )
        ) : (
          (advanceFeature ? (asyncFileName && asyncExperienceName && !linkError) : (asyncFileName && asyncExperienceName && !linkError)) && (
            <CreatorBtn
              showVideoBtn={true}
              enableVideoBtn={batchAsyncRole}
              loading={loading || (createReel && (upload || loading))}
              uploadVideo={() => onUploadReelVideo(false)}
              goNext={() => createReel ? onUploadReelVideo(true) : uploadAndGoNext()}
              isValidation={surveyLink ? !UtilService.validateSurveyLink(surveyLink) : false}
            />
          )
        )
      }
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
    </div>
  )
}

export default PreRecordedVideoPath;